import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
const ChevronIcon = ({ isOpen })=>/*#__PURE__*/ _jsx("svg", {
        className: `h-5 w-5 text-gray-500 transform transition-transform ${isOpen ? 'rotate-90' : ''}`,
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        strokeWidth: 2,
        children: /*#__PURE__*/ _jsx("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 5l7 7-7 7"
        })
    });
export const Accordion = ({ title, children, defaultOpen = false, className = '', headerClassName = '', contentClassName = '', icon, badge })=>{
    const [isOpen, setIsOpen] = useState(defaultOpen);
    return /*#__PURE__*/ _jsxs("div", {
        className: `bg-white rounded-lg shadow ${className}`,
        children: [
            /*#__PURE__*/ _jsx("button", {
                onClick: ()=>setIsOpen(!isOpen),
                className: `w-full px-4 py-3 flex items-center justify-between hover:bg-gray-50 transition-colors ${headerClassName}`,
                "aria-expanded": isOpen,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-3",
                    children: [
                        /*#__PURE__*/ _jsx(ChevronIcon, {
                            isOpen: isOpen
                        }),
                        icon && /*#__PURE__*/ _jsx("span", {
                            className: "text-gray-600",
                            children: icon
                        }),
                        /*#__PURE__*/ _jsx("h2", {
                            className: "text-lg font-semibold text-gray-900",
                            children: title
                        }),
                        badge !== undefined && /*#__PURE__*/ _jsx("span", {
                            className: "px-2 py-1 text-sm font-medium text-gray-600 bg-gray-100 rounded-md",
                            children: badge
                        })
                    ]
                })
            }),
            isOpen && /*#__PURE__*/ _jsx("div", {
                className: `px-4 pb-4 ${contentClassName}`,
                children: children
            })
        ]
    });
};
export const AccordionGroup = ({ children, className = '' })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: `space-y-4 ${className}`,
        children: children
    });
};
